import * as stylex from "@stylexjs/stylex";

import {
  content,
  error,
  footer,
  header,
  loading,
  success,
} from "./styles.stylex";

interface SignInCardHeaderProps {
  title: string;
  subtitle?: string;
  style?: stylex.StyleXStyles;
}

function SignInCardHeader({ title, subtitle, style }: SignInCardHeaderProps) {
  return (
    <div {...stylex.props(header.wrapper, style)}>
      <h1 {...stylex.props(header.title)}>{title}</h1>
      {subtitle && <p {...stylex.props(header.subtitle)}>{subtitle}</p>}
    </div>
  );
}

interface SignInCardErrorProps {
  message: string | null | undefined;
  style?: stylex.StyleXStyles;
}

function SignInCardError({ message, style }: SignInCardErrorProps) {
  if (!message) {
    return null;
  }
  return <div {...stylex.props(error.container, style)}>{message}</div>;
}

interface SignInCardContentProps {
  children: React.ReactNode;
  style?: stylex.StyleXStyles;
}

function SignInCardContent({ children, style }: SignInCardContentProps) {
  return <div {...stylex.props(content.container, style)}>{children}</div>;
}

interface SignInCardFooterProps {
  children: React.ReactNode;
  style?: stylex.StyleXStyles;
}

function SignInCardFooter({ children, style }: SignInCardFooterProps) {
  return <p {...stylex.props(footer.container, style)}>{children}</p>;
}

interface SignInCardLoadingProps {
  message?: string;
  style?: stylex.StyleXStyles;
}

function SignInCardLoading({
  message = "Loading...",
  style,
}: SignInCardLoadingProps) {
  return (
    <div {...stylex.props(loading.container, style)}>
      <div {...stylex.props(loading.message)}>{message}</div>
      <div {...stylex.props(loading.spinner)} />
    </div>
  );
}

interface SignInCardSuccessProps {
  message?: string;
  style?: stylex.StyleXStyles;
}

function SignInCardSuccess({
  message = "Successfully signed in!",
  style,
}: SignInCardSuccessProps) {
  return <div {...stylex.props(success.container, style)}>{message}</div>;
}

export {
  SignInCardHeader,
  SignInCardError,
  SignInCardContent,
  SignInCardFooter,
  SignInCardLoading,
  SignInCardSuccess,
  type SignInCardHeaderProps,
  type SignInCardErrorProps,
  type SignInCardContentProps,
  type SignInCardFooterProps,
  type SignInCardLoadingProps,
  type SignInCardSuccessProps,
};
